
import { toRefs, reactive, defineComponent, computed, ref, unref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { initFrontEndControlRoutes } from '@/router/frontEnd'
// import { initBackEndControlRoutes } from '@/router/backEnd'
import { useStore } from '@/store/index.ts'
import { Session } from '@/utils/storage'
import { formatAxis } from '@/utils/formatTime'
import { signIn } from '@/api/login/index'
export default defineComponent({
  name: 'login',
  setup () {
    const { t } = useI18n()
    // const { proxy } = getCurrentInstance() as any
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const ruleFormsss = ref()
    const state = reactive({
      isShowPassword: false,
      ruleForm: {
        userName: '',
        password: '',
        code: '1234'
      },
      rules: {
        userName: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      },
      loading: {
        signIn: false
      }
    })

    // 时间获取
    const currentTime = computed(() => {
      return formatAxis(new Date())
    })
    // 登录
    const onSignIn = async () => {
      const form = unref(ruleFormsss)
      if (!form) return
      try {
        await form.validate()
      } catch (error) {
        return
      }
      state.loading.signIn = true
      let defaultAuthPageList: Array<string> = []
      let defaultAuthBtnList: Array<string> = []
      // admin 页面权限标识，对应路由 meta.auth，用于控制路由的显示/隐藏
      const adminAuthPageList: Array<string> = ['admin']
      // admin 按钮权限标识
      const adminAuthBtnList: Array<string> = ['btn.add', 'btn.del', 'btn.edit', 'btn.link']
      // test 页面权限标识，对应路由 meta.auth，用于控制路由的显示/隐藏
      const testAuthPageList: Array<string> = ['test']
      // test 按钮权限标识
      const testAuthBtnList: Array<string> = ['btn.add', 'btn.link']
      // 不同用户模拟不同的用户权限
      if (state.ruleForm.userName === 'admin') {
        defaultAuthPageList = adminAuthPageList
        defaultAuthBtnList = adminAuthBtnList
      } else {
        defaultAuthPageList = testAuthPageList
        defaultAuthBtnList = testAuthBtnList
      }
      // let login:any = ''
      try {
        const login : any = await signIn({ username: state.ruleForm.userName, password: state.ruleForm.password })
        if (login.data === null) {
          state.loading.signIn = false
          ElMessage.error('用户名、密码不正确或用户被禁用！')
          return
        }

        // 用户信息模拟数据
        const userInfos:any = {
          userName: login.data.userName,
          photo:
					state.ruleForm.userName === 'admin' ? 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=1813762643,1914315241&fm=26&gp=0.jpg' : 'https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=317673774,2961727727&fm=26&gp=0.jpg',
          time: new Date().getTime(),
          authPageList: defaultAuthPageList,
          authBtnList: defaultAuthBtnList
        }
        // 存储 token 到浏览器缓存
        Session.set('token', login.tnToken.tokenStr)
        // 存储用户信息到浏览器缓存
        Session.set('userInfo', userInfos)
        // 1、请注意执行顺序(存储用户信息到vuex)
        store.dispatch('userInfos/setUserInfos', userInfos)
        if (!store.state.themeConfig.themeConfig.isRequestRoutes) {
        // 前端控制路由，2、请注意执行顺序
          await initFrontEndControlRoutes()
          signInSuccess()
        } else {
        // 模拟后端控制路由，isRequestRoutes 为 true，则开启后端控制路由
        // 添加完动态路由，再进行 router 跳转，否则可能报错 No match found for location with path "/"
        // await initBackEndControlRoutes()
        // 执行完 initBackEndControlRoutes，再执行 signInSuccess
          signInSuccess()
        }
      } catch (error:any) {
        ElMessage.error(error.message)
        state.loading.signIn = false
      }
    }
    // 登录成功后的跳转
    const signInSuccess = () => {
      // 初始化登录成功时间问候语
      const currentTimeInfo = currentTime.value
      // 登录成功，跳到转首页
      // 添加完动态路由，再进行 router 跳转，否则可能报错 No match found for location with path "/"
      // 如果是复制粘贴的路径，非首页/登录页，那么登录成功后重定向到对应的路径中
      if (route.query?.redirect) {
        router.push({
          path: route.query?.redirect as string,
          query: Object.keys(route.query?.params as string).length > 0 ? JSON.parse(route.query?.params as string) : ''
        })
      } else {
        router.push('/')
      }
      // 登录成功提示
      setTimeout(() => {
        // 关闭 loading
        state.loading.signIn = true
        const signInText = t('message.signInText')
        ElMessage.success(`${currentTimeInfo}，${signInText}`)
        // 修复防止退出登录再进入界面时，需要刷新样式才生效的问题，初始化布局样式等(登录的时候触发，目前方案)
        // proxy.mittBus.emit('onSignInClick')
      }, 300)
    }
    return {
      currentTime,
      ruleFormsss,
      onSignIn,
      ...toRefs(state)
    }
  }
})
